import { create } from "zustand";

const userInfo = {
  id: 1,
  firstname: "Peter",
  lastname: "Parker",
};

export const useUserStore = create((set) => ({
  user: null,
  setUser: (info) => set({ user: info }),
}));
